import { definePermisos } from '../utils'

export const RESOURCE_PROYECTOS_TI = 'ProyTI' as const
export const permissionTree = definePermisos(RESOURCE_PROYECTOS_TI, 'proyectos-ti', {
    mantenimiento: {
        cargos: 'cargos',
    },
})
